$(document).on('ajax:before', '#file-check-container a[data-remote]', function() {
  return $($(this).data("target")).find(".file-check-icon").removeClass().addClass("fa fa-refresh fa-spin file-check-icon");
});
